// Companies data
export const companiesData = [
  {
    id: 1,
    name: 'Mercedes-Benz Ludwigsfelde GmbH',
    logoPath: '/assets/MB-logo.png',
    logoText: 'MB',
    website: 'https://www.mercedes-benz.de/vans.html',
    photoPath: '/assets/photo_mercedes.jpg',
    mapsLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.234567!2d13.2693788!3d52.3206631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a85d6c453f49c3%3A0x26b6ecce877d7192!2sMercedes-Benz%20Ludwigsfelde%20GmbH!5e0!3m2!1sen!2sde!4v1663234567890'
  },
  {
    id: 2,
    name: 'FERCHAU GmbH',
    logoPath: '/assets/FE-logo.png',
    logoText: 'FE',
    website: 'https://www.ferchau.com/',
    photoPath: '/assets/photo_ferchau.jpg',
    mapsLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2520.123456!2d13.0335718!3d52.3904313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a8f4357f4f7fa1%3A0xbf26af6d670ff3fb!2sFERCHAU%20GmbH!5e0!3m2!1sen!2sde!4v1663234567890'
  },
  {
    id: 3,
    name: 'SIEMENS AG',
    logoPath: '/assets/SIE-logo.png',
    logoText: 'SI',
    website: 'https://www.siemens.com/',
    photoPath: '/assets/photo_siemens.jpg',
    mapsLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2662.123456!2d13.2602919!3d52.537803!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a85685a3061c17%3A0xf2120474abc1d00!2sSiemens%20AG!5e0!3m2!1sen!2sde!4v1663234567890'
  },
  {
    id: 4,
    name: 'Brandenburg University of Applied Sciences',
    logoPath: '/assets/THB-logo.png',
    logoText: 'THB',
    website: 'https://www.th-brandenburg.de/',
    photoPath: '/assets/photo_thb.jpg',
    mapsLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2412.345678!2d12.5369419!3d52.411708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a8c0e57da067bf%3A0xdea4f4c1ce2f697c!2sTechnische%20Hochschule%20Brandenburg!5e0!3m2!1sen!2sde!4v1663234567890'
  },
  {
    id: 5,
    name: 'University of Rostock',
    logoPath: '/assets/HRO-logo.png',
    logoText: 'HRO',
    website: 'https://www.uni-rostock.de/',
    photoPath: '/assets/photo_university_rostock.jpg',
    mapsLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2350.067398!2d12.1332558!3d54.0880944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47ac57547415f611%3A0xcefe384549c99eb2!2sUniversit%C3%A4t%20Rostock%2C%20Hauptgeb%C3%A4ude%2C%20Universit%C3%A4tspl.%2001%2C%2018055%20Rostock%2C%20Deutschland!5e0!3m2!1sen!2sde!4v1663234567890'
  }
];
